import { axiosInstance as axios } from 'hb-react/shared/utils/axios';

export function incrementView(uuid) {
  axios.put(Routes.counters_media_center_v2_files_path(uuid), {
    view: true,
  });
}

export function incrementDownload(uuid) {
  axios.put(Routes.counters_media_center_v2_files_path(uuid), {
    download: true,
  });
}
